import { Component, OnInit, EventEmitter, Output, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { AppService } from '../../../services/app.service';
import { MasterService } from '../../../services/master.service';

@Component({
  selector: 'app-page-access-edit-form',
  templateUrl: './page-access-edit-form.component.html',
  styleUrls: ['./page-access-edit-form.component.scss']
})
export class PageAccessEditFormComponent implements OnInit {
  @Output() closeDialogue = new EventEmitter();
  
  dialogHeader : string = "";

  generalId : Number = 0;
  formGroup: FormGroup;
  formGroupErrors: any;

  loadingIndicator = false;
  reorderable = true;

  translations: any;
  pageList: any = [];
  constructor( @Inject(MAT_DIALOG_DATA)
  public data: { Id : 0},
  public dialog: MatDialog,
  private formBuilder: FormBuilder,
  public appService: AppService,
  public masterService : MasterService,
  public dialogRef: MatDialogRef<PageAccessEditFormComponent>){
    this.appService.showLoading();
    this.setPageTranslations();
    this.formGroupErrors = {
    };

    this.formGroup = this.formBuilder.group({
        });
    this.generalId = this.data.Id;
  }
  
  ngOnInit() {
   
    this.getPages();
  }
  setPageTranslations(){
    this.translations = JSON.parse(sessionStorage.getItem('pageData')); 
  }
  
  getPages(): void {
    this.masterService.selectPageAccess(this.generalId).subscribe(
      res => this.getPagesSuccessCallback(res),
      error => this.apiFailure(error)
    );
  }

  getPagesSuccessCallback(res): void {
    this.appService.hideLoading();
    if (res['Status'] == '1') {

      this.pageList = JSON.parse(res.Data);
      this.appService.hideLoading();
    }
    else {
      this.pageList = [];
    }
  }


  apiFaillure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(this.translations.hdError, this.translations[error]);
  }
  close(){
    this.dialogRef.close();
  }

  change(e, page): void {
    if(e.checked){
      page.CanView = true;
    }
  }

  save():void{
    this.appService.showLoading();
    this.masterService.paSave(JSON.stringify(this.pageList)).subscribe(
      res => this.savePageAccess(res),
      error => this.apiFailure(error)
    );
  }

  savePageAccess(res): void { 
    this.appService.hideLoading();
    if (res['Status'] == '1') {
     this.appService.showDialogue(this.translations.hdSuccess,this.translations[res.Message]) .afterClosed().subscribe(result => {
      if (result) {
        this.close();
      }          
  });    
    }
    else {
      this.apiFailure(res.Message);
    }
  }

  
  apiFailure(error): void {
    this.appService.hideLoading();
    this.appService.showDialogue(this.translations.hdError,this.translations[error]);
    
  }
  
}






// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/general/page-access-edit-form/page-access-edit-form.component.ts